// extracted by mini-css-extract-plugin
module.exports = {"svgLogo":"PIELoader__svgLogo___2Z0HN","animationStyles":"PIELoader__animationStyles___3crjK","PIEAnimate":"PIELoader__PIEAnimate____AK_s"};